import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
/**
 * Created by h3 on 2018-10-17.
 */
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {FruitsSoundConfig} from "../FruitsSoundConfig";


export class SoundHandler {

    private _countActive:boolean = true;

    public startCountUp() {
        SlotGame.sound.playEffect(FruitsSoundConfig.COUNTUP, -1);
        this._countActive = true;
    }

    public stopCountUp(shouldPlayStopSound:boolean = true) {
        SlotGame.sound.stopEffect(FruitsSoundConfig.COUNTUP);
        if(this._countActive && shouldPlayStopSound) {
            SlotGame.sound.playEffect(FruitsSoundConfig.COUNTUP_ENDS);
        }
        this._countActive = false;
    }

    public playInitialWinSound(winRatioConfig:IWinRatioConfig) {
        let soundName:string = "";
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                soundName = FruitsSoundConfig.WIN_TINY;
                break;
            case WinRatioType.SMALL:
                soundName = FruitsSoundConfig.WIN_SMALL;
                break;
            case WinRatioType.MEDIUM:
                soundName = FruitsSoundConfig.WIN_MEDIUM;
                break;
            case WinRatioType.LARGE:
                soundName = FruitsSoundConfig.WIN_LARGE;
                break;
            default:
                soundName = "";
                break;
        }

        SlotGame.sound.playEffect(soundName);
    }

    public playBigWinEndSound(winLevel:number) {
        let soundName:string = "";
        switch(winLevel) {
            case 0:
                soundName = FruitsSoundConfig.BIG_WIN_ENDS_1;
                break;
            case 1:
                soundName = FruitsSoundConfig.BIG_WIN_ENDS_2;
                break;
            case 2:
                soundName = FruitsSoundConfig.BIG_WIN_ENDS_3;
                break;
            default:
                soundName = "";
                break;
        }

        SlotGame.sound.playEffect(soundName);
    }

}